import styles from "./DataRoomSection.module.scss";

import { Typography } from "@/frontend/shared/ui/Typography";
import { useState } from "react";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { EntryPointsIcon } from "@/frontend/shared/assets/icons";
import { EActiveView } from "@/frontend/features/Company/model/types/types";
import { AddCompaniesToPipelineModal } from "@/frontend/components/AddCompaniesToPipelineModal/AddCompaniesToPipelineModal";

type TDataRoomSectionProps = {
  id: number;
  triggerRefetch: () => void;
  companyName: string;
  switchSection: (section: EActiveView) => void;
};

export type TSectionOption = {
  section: string;
  filename: string;
  id: number;
};

export function DataRoomSection({ id, triggerRefetch, companyName, switchSection }: TDataRoomSectionProps) {
  const [isAddToPipelineModalOpen, setIsAddToPipelineModalOpen] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.infoContainer}>
        <Typography variant="heading-6" color="greyscale800">
          Add to Pipeline
        </Typography>
        <Typography variant="body-2" color="greyscale800">
          Add the company to your pipeline to upload files to the data room
        </Typography>
        <NormalButton
          size="large"
          variant="secondary"
          className={styles.inviteButton}
          onClick={() => setIsAddToPipelineModalOpen(true)}
        >
          <EntryPointsIcon />
          Add to Pipeline
        </NormalButton>
      </div>
      <AddCompaniesToPipelineModal
        ids={[id || 0]}
        triggerRefetch={triggerRefetch}
        isOpen={isAddToPipelineModalOpen}
        onClose={() => setIsAddToPipelineModalOpen(false)}
      />
    </div>
  );
}
